import React from 'react';

import { BoxContainer } from '../../components';
import AddTruckForm from './components/AddTruckForm';

const PageContent = () => {
  return (
    <BoxContainer $useMarginBottom $useMarginTop>
      <AddTruckForm />
    </BoxContainer>
  );
};

export default PageContent;
